module.exports = __webpack_public_path__ + "static/media/22ESCWA12.c7fb751a.jpg";